import { render, staticRenderFns } from "./add_appraise.vue?vue&type=template&id=04d40291&scoped=true"
import script from "./add_appraise.vue?vue&type=script&lang=js"
export * from "./add_appraise.vue?vue&type=script&lang=js"
import style0 from "./add_appraise.vue?vue&type=style&index=0&id=04d40291&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d40291",
  null
  
)

export default component.exports